import { Typography } from '@mui/material';
import type React from 'react';
import styles from 'src/components/NotFound/NotFoundStyles';

const NotFound: React.FC = () => {
  const classes = styles();
  return (
    <div className={classes.errorContainer}>
      <Typography className={classes.largeText} color="error" component="h1" variant="h1">
        404
      </Typography>
      <Typography color="error" component="h2" variant="h2">
        Page Not Found
      </Typography>
    </div>
  );
};

export default NotFound;
